import { Component } from "@angular/core";
import { faFacebookSquare, faInstagram, faLinkedinIn, faPinterest, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { scrollToTop } from 'src/infrastructure/utils';

@Component({
	selector: 'ab-footer',
	templateUrl: 'footer.component.html',
	styleUrls: ['footer.component.scss']
})
export class FooterComponent {
	faAngleUp = faAngleUp;
	faFacebookSquare = faFacebookSquare;
	faInstagram = faInstagram;
	faTwitter = faTwitter;
	faLinkedinIn = faLinkedinIn;
	faPinterest = faPinterest;
	faYoutube = faYoutube;
	currentLang: string = '';
	currentYear = new Date().getFullYear();

	constructor(
		translateService: TranslateService
	) {
		translateService.onLangChange.subscribe((e: LangChangeEvent) => this.currentLang = e.lang);
	}

	otherLinks = [
		{ url: 'https://explore.openaire.eu', name: 'footer.other.openair' },
		{ url: 'https://www.eosc-portal.eu', name: 'footer.other.eosc' },
		{ url: 'https://www.eoscsecretariat.eu', name: 'footer.other.eoscsecretariat' },
		{ url: 'https://www.eosc-hub.eu/services', name: 'footer.other.eoschub' },
		{ url: 'https://rda.bg/', name: 'footer.other.rda' },
		{ url: 'https://doaj.org', name: 'footer.other.doaj' },
		{ url: 'https://v2.sherpa.ac.uk/opendoar', name: 'footer.other.doar' },
		{ url: 'http://sherpa.ac.uk/romeo/index.php', name: 'footer.other.SherpaRoMEO' },
		{ url: 'https://www.esfri.eu', name: 'footer.other.esfri' },
		{ url: 'https://ec.europa.eu/info/horizon-europe-next-research-and-innovation-framework-programme_en', name: 'footer.other.horizon' },
	];

	scrollToTop() {
		scrollToTop();
	}
}
